import { render, staticRenderFns } from "./CortesiasEventoJefePuntoVenta.vue?vue&type=template&id=4c976352"
import script from "./CortesiasEventoJefePuntoVenta.vue?vue&type=script&lang=js"
export * from "./CortesiasEventoJefePuntoVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports